import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import {AppComponent} from '../../app.component';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { element } from 'protractor';

@Component({
    selector: 'app-email-log',
    templateUrl: './email-log.component.html',
    styleUrls: ['./email-log.component.css'],
    standalone: false
})
export class EmailLogComponent implements OnInit {

  master: any;
  url: string;
  pageurl: string;
  TypeHeader: string;
  MsgType: number;
  pageNumber: number = 1;
  DisplayMessage: string;
  FormSearchNoticeCase: FormGroup;
  advanceSearchValue: any;
  modalURL: any;
  ModelFor: string;
  CallFunctionOnCloseModal: any;
  RequestFrom: string;
  selectedAll: any;
  isSelected: boolean[];
  RightsID: string;
  pageSize = 10;
  pageIndex = 0;
  totalRecords = 0;
  FormSearchEmailLog: FormGroup;
  filteredData: any[];

  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder) { this.url = AppComponent.baseURL; }


  ngOnInit() {
    this.getEmailLog();
    this.FormSearchEmailLog = this.formBuilder.group({
      txtSearch: ['']
    })
    this.FormSearchEmailLog.get('txtSearch').valueChanges.pipe(debounceTime(300),distinctUntilChanged()).subscribe(value => {
      this.filterTable(value);
    })
  }

  onSearchEmailLog(value){
    this.filterTable(value);
  }
  filterTable(searchText: string) {
    if (!searchText) {
      this.filteredData = [...this.master];
      return;
    }
    this.filteredData = this.master.filter(row =>
      Object.values(row).some(val =>
        val?.toString().toLowerCase().includes(searchText.toLowerCase())
      )
    );
    this.pageNumber = 1;
  }
  getEmailLog() {
    this.http.get(this.url + 'Report/view_Email_Log')
    .subscribe( (data) => {
        if (data == null || data.toString() == "[]") {
          this.MsgType = 2; // No Data Found
          this.DisplayMessage = "No Data Found";
          this.master = '';
        } else {
          this.MsgType = 0; // No Message
          this.master = JSON.parse(data.toString());
          this.totalRecords = this.master.length;
          this.filterTable('');
        }
      },
      (error) => {
         this.MsgType = 3; // Error Message
         this.DisplayMessage = error.message;
       }
    );
  }
  onPageSizeChange(size: number) {
    this.pageSize = size;
    this.pageNumber = 1; 
  }
}
